import { ChevronDown } from 'lucide-react'
import * as React from 'react'

import { cn } from '@/lib/utils'

/**
 * Seleção de valor único.
 *
 * É o `<select>` NATIVO, e não um menu do Radix, por três motivos concretos:
 * no celular ele abre o seletor do sistema (que é melhor do que qualquer lista
 * que a gente desenhe em 375px), ele já é navegável por teclado e leitor de
 * tela sem uma linha de ARIA, e ele funciona dentro de `<form>` sem estado
 * paralelo. O estilo é nosso; o comportamento é do sistema operacional.
 *
 * A seta é desenhada por cima porque `appearance-none` remove a nativa junto
 * com o resto da aparência padrão.
 */
export type SelectProps = React.SelectHTMLAttributes<HTMLSelectElement>

const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, children, ...props }, ref) => (
    <div className="relative">
      <select
        ref={ref}
        data-slot="select"
        className={cn(
          'flex h-10 w-full appearance-none rounded-lg border border-border bg-surface',
          'px-3 py-2 pr-9 text-sm text-foreground transition-colors',
          'focus-visible:border-border-strong focus-visible:outline-none focus-visible:ring-2',
          'focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDown
        aria-hidden="true"
        className={cn(
          'pointer-events-none absolute right-3 top-1/2 size-4 -translate-y-1/2',
          'text-fg-muted',
        )}
      />
    </div>
  ),
)
Select.displayName = 'Select'

export { Select }
